import { AppLayout } from '@/shared/ui/app-layout';
import { createFileRoute, Outlet } from '@tanstack/react-router';

function AppLayoutRoute() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}

export const Route = createFileRoute('/_app')({
  component: AppLayoutRoute,
});
